module.exports = __webpack_public_path__ + "static/media/neogeo.7527c136.mp4";